import { Utensils, LogOut, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = ({ onAdd }) => {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-50 bg-sand/85 backdrop-blur-xl border-b border-[#E8E3D9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-4">
        <span className="grid h-9 w-9 place-items-center rounded-lg bg-forest shrink-0">
          <Utensils className="h-4 w-4 text-sand" strokeWidth={2.2} />
        </span>
        <div className="min-w-0">
          <p className="font-heading font-semibold text-deep-olive leading-tight truncate">
            MBG Tracker
          </p>
          <p className="text-xs text-stone-grey truncate" data-testid="header-user-email">
            {user?.email}
          </p>
        </div>

        <div className="ml-auto flex items-center gap-2">
          <Button
            data-testid="add-meal-button"
            onClick={onAdd}
            className="h-10 rounded-full bg-forest px-4 sm:px-5 text-sand hover:bg-forest-hover transition-colors duration-200"
          >
            <Plus className="h-4 w-4 sm:mr-1.5" strokeWidth={2.4} />
            <span className="hidden sm:inline">Log meal</span>
          </Button>
          <Button
            data-testid="logout-button"
            variant="ghost"
            onClick={logout}
            className="h-10 rounded-full px-3 text-stone-grey hover:bg-surface-hover hover:text-deep-olive transition-colors duration-200"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
};
